import React from "react";

export const EMMA_AVATAR_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_measure-estimate-2/artifacts/zl63xiu6_B792310E-EDCD-47E2-A789-0F3FAC962611.jpeg";

export default function EmmaAvatar({ size = 44, className = "", testId = "emma-avatar" }) {
  return (
    <div className={`relative ${className}`} data-testid={testId}>
      <div
        className="relative rounded-full overflow-hidden ring-2 ring-[#E5E2DC] hover:ring-[#D96C4A] transition bg-[#1a1a18]"
        style={{ width: size, height: size }}
      >
        <img
          src={EMMA_AVATAR_URL}
          alt="Emma — EmmaMeasure assistant"
          className="object-cover w-full h-full"
          draggable="false"
        />
      </div>
    </div>
  );
}
